<!--
 * @Description: 部门管理
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-01-29 10:51:17
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2022-01-20 13:39:54
 -->
<template>
  <div class="deptMana">
    <div class="listContainer">
      <div class="topInfo">
        <div class="listTitle">部门管理</div>
        <div class="handleArea">
          <el-button class="addButton" icon="el-icon-circle-plus-outline" type="danger" round @click="add">新增</el-button>
        </div>
      </div>
      <div class="deptTree">
        <el-tree
          :data="superDeptTree"
          node-key="id"
          :default-expand-all="true"
          :props="superDeptTreeProps"
          :expand-on-click-node="true">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button
                type="text"
                size="mini"
                class="detailDeptBtn el-icon-document"
                @click.stop="showDetail(node, data)">
                详情
              </el-button>
              <el-button
                type="text"
                size="mini"
                class="addDeptBtn el-icon-circle-plus-outline"
                @click.stop="add(node, data)">
                新增
              </el-button>
              <el-button
                type="text"
                size="mini"
                class="modifyDeptBtn el-icon-edit-outline"
                @click.stop="modifyDept(node, data)">
                修改
              </el-button>
              <el-button
                type="text"
                size="mini"
                class="deleteDeptBtn el-icon-delete"
                @click.stop="deleteDept(node, data)">
                删除
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
    </div>
    <!-- 新增平台 弹框 start -->
    <el-dialog
      class="addUserDialog"
      @closed="addDialogClosed"
      :title="addDialogTitle"
      :visible.sync="addDialogVisible">
      <div class="content">
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>部门编码：</span>
          <el-input v-model="code" :maxlength="18" :disabled="dialogType === 'detail'" placeholder="请输入部门编码"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>部门名称：</span>
          <el-input v-model="name" :maxlength="48" :disabled="dialogType === 'detail'" placeholder="请输入部门名称"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title">部门简称：</span>
          <el-input v-model="shortName" :maxlength="18" :disabled="dialogType === 'detail'" placeholder="请输入部门简称"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title">上级部门：</span>
          <el-cascader
            v-model="superDept"
            @change="superDeptSelectChange"
            :show-all-levels="false"
            :disabled="dialogType === 'detail'"
            clearable
            :options="superDeptTree"
            :props="superDeptProps"></el-cascader>
        </div>
        <div class="userInfoItem">
          <span class="title">责任人：</span>
          <el-select v-model="liablerId" @change="liablerChange" :disabled="dialogType === 'detail'" placeholder="请选择责任人">
            <el-option
              v-for="item in usersOptions"
              :key="item.id"
              :label="item.realname"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="userInfoItem">
          <span class="title"><span class="required">*</span>启用状态：</span>
          <el-select v-model="state" :disabled="dialogType === 'detail'" placeholder="请选择启用状态">
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="userInfoItem">
          <span class="title">排序：</span>
          <el-input v-model="sort" type="number" :disabled="dialogType === 'detail'" placeholder="请输入排序号"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title">地址：</span>
          <el-input v-model="address" :maxlength="48" :disabled="dialogType === 'detail'" placeholder="请输入地址"></el-input>
        </div>
        <div class="handleArea" v-if="dialogType !== 'detail'">
          <el-button type="primary" size="medium" @click="confirmDetailDialog">{{dialogType === 'modify' ? '修改' : '新增'}}</el-button>
          <el-button type="danger" size="medium" @click="cancelDetailDialog">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增平台 弹框 end -->
  </div>
</template>

<script>
// import BasePagination from '@/components/BasePagination'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'deptMana',
  components: {
    // BasePagination,
  },
  computed: {
    ...mapState([
      'selectedSystem',
    ]),
  },
  data () {
    return {
      dialogType: '',
      // 新增平台参数start
      id: '',
      platformId: '',
      code: '',
      name: '',
      shortName: '',
      superDept: null,
      state: '',
      liabler: '',
      liablerId: '',
      sort: '',
      address: '',
      // 新增平台参数end
      // 上级部门数据树
      superDeptTree: [],
      superDeptTreeProps: {
        label: 'name',
        children: 'childs',
      },
      // 责任人选择配置项
      usersOptions: [],
      // 上级部门级联选择配置
      superDeptProps: {
        checkStrictly: true,
        value: 'id',
        label: 'name',
        children: 'childs',
      },
      // 平台状态配置项
      stateOptions: [
        {
          value: true,
          label: '启用',
        },
        {
          value: false,
          label: '禁用',
        },
      ],
      addDialogVisible: false,
      addDialogTitle: '',
    }
  },
  watch: {
    // 监听平台选择
    selectedSystem (val) {
      if (val !== '') {
        // 部门树
        this.getSuperDeptTree(val)
        // 用户
        this.getUsersData(val)
      }
    },
  },
  methods: {
    ...mapMutations([
      'setGlobalPlatformSelecter',
    ]),
    /**
     * @description             获取平台树形数据
     * @param {String}          平台id
     * @return {undefined}      无返回值
     */
    getSuperDeptTree (pid) {
      this.$http.post('/api/dept/tree', {
        pid: pid,
      }).then(res => {
        if (res.code === 'success') {
          this.superDeptTree = res.data.list
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    /**
     * @description             获取用户列表
     * @param {String}          平台id
     * @return {undefined}      无返回值
     */
    getUsersData (pid) {
      this.$http.post('/api/user/platform-users', {
        pid: pid,
      }).then(res => {
        if (res.code === 'success') {
          this.usersOptions = res.data.list
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
    /**
     * @description             责任人选择change事件
     * @param {Object}          事件对象
     * @return {undefined}      无返回值
     */
    liablerChange (e) {
      this.usersOptions.map(item => {
        if (item.id === e) {
          this.liabler = item.realname
        }
      })
    },
    /**
     * @description             上级部门选择change事件
     * @param {undefined}       当前选择值
     * @return {undefined}      无返回值
     */
    superDeptSelectChange (e) {
      console.log('上级部门选择change事件', e)
    },
    /**
     * @description             详情
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    showDetail (node, data) {
      this.dialogType = 'detail'
      this.addDialogTitle = '平台详情'
      this.addDialogVisible = true
      this.id = data.id
      this.platformId = data.platformId
      this.code = data.code
      this.name = data.name
      this.shortName = data.shortName
      this.state = data.state
      this.liabler = data.liabler
      this.liablerId = data.liablerId
      this.sort = data.sort
      this.address = data.address
      let deptPathArr = data.path.split('/').slice(0, -1)
      deptPathArr.map((item, index) => {
        deptPathArr[index] = parseFloat(item)
      })
      deptPathArr.shift()
      deptPathArr.pop()
      this.superDept = deptPathArr
    },
    /**
     * @description             删除平台按钮
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    deleteHandle (row) {
      let params = {
        ids: row.id,
      }
      this.$http.post('/api/platform/delete', params)
        .then(res => {
          if (res.code === 'success') {
            this.$notify({
              message: '删除成功！',
              type: 'success',
            })
            this.initListData()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description             新增部门
     * @param {Object}          节点node
     * @param {Object}          节点部门数据
     * @return {undefined}      无返回值
     */
    add (node, data) {
      this.dialogType = 'add'
      this.addDialogTitle = '新增部门'
      this.addDialogVisible = true
      if (data) {
        let deptPathArr = data.path.split('/')
        deptPathArr.map((item, index) => {
          deptPathArr[index] = parseFloat(item)
        })
        deptPathArr.shift()
        deptPathArr.pop()
        this.superDept = deptPathArr
      }
    },
    /**
     * @description             删除部门
     * @param {Object}          节点node
     * @param {Object}          节点部门数据
     * @return {undefined}      无返回值
     */
    deleteDept (node, data) {
      this.$confirm('是否删除部门-' + data.name + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.post('/api/dept/delete', {
          ids: data.id,
        }).then(res => {
          if (res.code === 'success') {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.getSuperDeptTree(this.selectedSystem)
          } else {
            this.$message({
              type: 'error',
              message: res.msg,
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    /**
     * @description             修改部门
     * @param {Object}          节点node
     * @param {Object}          节点部门数据
     * @return {undefined}      无返回值
     */
    modifyDept (node, data) {
      this.dialogType = 'modify'
      this.addDialogTitle = '修改部门'
      this.addDialogVisible = true

      this.id = data.id
      this.platformId = data.platformId
      this.code = data.code
      this.name = data.name
      this.shortName = data.shortName
      this.state = data.state
      this.liabler = data.liabler
      this.liablerId = data.liablerId
      this.sort = data.sort
      this.address = data.address
      let deptPathArr = data.path.split('/').slice(0, -1)
      deptPathArr.map((item, index) => {
        deptPathArr[index] = parseFloat(item)
      })
      deptPathArr.shift()
      deptPathArr.pop()
      this.superDept = deptPathArr
    },
    /**
     * @description             置空部门信息
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    clearInfo () {
      this.id = ''
      this.platformId = ''
      this.code = ''
      this.name = ''
      this.shortName = ''
      this.superDept = []
      this.state = ''
      this.liabler = ''
      this.liablerId = ''
      this.sort = ''
      this.address = ''
    },
    /**
     * @description             取消新增或修改
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    cancelDetailDialog () {
      this.addDialogVisible = false
      this.clearInfo()
    },
    /**
     * @description             确认新增或修改
     * @param {undefined}       新增时：无
     * @param {id}              修改时：id
     * @return {undefined}      无返回值
     */
    confirmDetailDialog () {
      if (!this.superDept && !this.selectedSystem) {
        this.$message({
          message: '上级部门为空时，平台为必选项！',
          type: 'warning',
        })
        return
      }
      if (!this.selectedSystem || !this.code || !this.state) {
        this.$message({
          message: '请填写完整！',
          type: 'warning',
        })
        return
      }
      let params = {
        platformId: this.selectedSystem,
        code: this.code,
        name: this.name,
        shortName: this.shortName,
        superDept: this.superDept && this.superDept.length ? this.superDept[this.superDept.length - 1] : '',
        state: this.state,
        liabler: this.liabler,
        liablerId: this.liablerId,
        sort: this.sort,
        address: this.address,
      }
      if (this.dialogType === 'modify') {
        params.id = this.id
      }

      this.$http.post('/api/dept/save', params)
        .then(res => {
          if (res.code === 'success') {
            this.addDialogVisible = false
            this.$notify({
              message: this.dialogType === 'modify' ? '修改成功！' : '新增成功！',
              type: 'success',
            })
            this.clearInfo()
            setTimeout(() => {
              this.getSuperDeptTree(this.selectedSystem)
            }, 500)
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description             详情框关闭时的回调
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    addDialogClosed () {
      this.clearInfo()
    },
  },
  created () {
    this.setGlobalPlatformSelecter(true)
    if (this.selectedSystem) {
      // 部门树
      this.getSuperDeptTree(this.selectedSystem)
      // 用户
      this.getUsersData(this.selectedSystem)
    }
  },
}
</script>

<style lang="less" scoped>
  .deptMana{
    width: 100%;
    height: 100%;

    .listContainer {
      width: 100%;
      height: calc(100% - 50px);

      .topInfo {
        width: calc(100% - 40px);
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        .listTitle {
          font-size: 26px;
          font-weight: bold;
        }
      }

      .deptTree {
        padding: 30px 150px;
        width: calc(100% - 300px);
        height: calc(100% - 60px);
        overflow-y: scroll;
        /deep/ .el-tree {
          .el-tree-node {
            .detailDeptBtn {
              margin-left: 50px;
              &:hover {
                color: #83c1ff;
              }
            }
            .addDeptBtn {
              color: #67C23A;
              &:hover {
                color: #a0e07f;
              }
            }
            .modifyDeptBtn {
              color: #E6A23C;
              &:hover {
                color: #f5be6d;
              }
            }
            .deleteDeptBtn {
              color: #F56C6C;
              &:hover {
                color: #f59595;
              }
            }
          }
        }
      }
    }

    /deep/.addUserDialog {
      .el-dialog {
        width: 960px;
        height: 640px;
        border-radius: 6px;
        .el-dialog__header {
          background: #2c63a3;
          border-radius: 6px 6px 0 0;
          padding: 10px 20px;
          .el-dialog__title {
            color: #fff;
          }
          .el-dialog__headerbtn {
            top: 10px;
            .el-dialog__close {
              color: #fff;
              font-size: 26px;
            }
          }
        }
        .el-dialog__body {
          height: calc(100% - 84px);
          padding: 20px;
          .content {
            width: 100%;
            height: 100%;
            position: relative;
            .userInfoItem {
              display: inline-block;
              width: 40%;
              margin: 30px 5%;
              .title {
                display: inline-block;
                width: 100px;
                text-align: right;
                .required {
                  color: #F56C6C;
                  margin-right: 6px;
                  vertical-align: middle;
                }
              }
              .el-input {
                width: 240px;
              }
            }

            .handleArea {
              text-align: right;
              position: absolute;
              bottom: 30px;
              right: 0;
            }
          }
        }
      }
    }
  }
</style>
